import React, { useState, useEffect } from 'react';
import { 
  Remove 
} from '@mui/icons-material';

import FabButton from "@components/input/buttons/FabButton";
import { Button } from '@mui/material';

interface Props {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  onClick: () => void;
}

export default function RemoveButton({ 
  disabled = false,
  label = "",
  label_separate = false,
  onClick 
}: Props) {
  const [is_disabled, setDisabled] = useState(disabled);

  useEffect(() => {
    setDisabled(disabled);
  }, [disabled]);

  const className =`${is_disabled ? " disabled" : ""}`;

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <Remove/>
      </FabButton>
    );
  } else {
    if (label_separate) {
      return (
        <>
          <FabButton
            disabled={disabled} 
            onClick={onClick}>
            <Remove/>
          </FabButton>&nbsp;
          <span className="header">{ label }</span>
        </>
      );
    } else {
      return (
        <Button
          className={className}
          disabled={disabled} 
          onClick={onClick}
          variant="contained" color="primary">
          <Remove/>&nbsp;{ label }
        </Button>
      );
    }
  }
}
